import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { RestApi } from "src/app/shared/RestApi/restApi";
import { Router } from '@angular/router';
import {lastValueFrom, Observable} from 'rxjs';


interface AvailService{
  statusMessage: any;
  error: boolean;
  data: any;
  [Symbol.iterator](): Iterator<any>;
}

@Injectable({
  providedIn: "root"
})

@Injectable({
  providedIn: 'root'
})
/**
 * Author: Abhishek T
 * Date: October 16, 2023
 */
export class AvailableServiceTsService {
  private headers = new HttpHeaders({
    "Content-Type": "application/json"
    });
    constructor(
      private http: HttpClient,
      private snackBar: MatSnackBar,
      private spinner: NgxUiLoaderService,
      private restAPI: RestApi,
      private router: Router
    ) { }
    /**
   * Retrieves available services from the API.
   * @returns An Observable with AvailService structure.
   */
    public retrieveAvailService(): Observable<AvailService> {
      return this.http.get<AvailService>(this.restAPI.RETRIVE_AVAILABLE_SERVICE, { headers: this.headers });
    }
  
    /**
     * Saves or updates available services based on the action type and the provided object.
     * @param actiontype - Action type, e.g., 'save' or 'update'.
     * @param obj - Data object containing information about available services.
     * @returns An Observable with the API response.
     */
    saveAvailServices(actiontype: string, obj: any): Observable<any> {
      return this.http.post<any>(this.restAPI.SAVE_AVAILABLE_SERVICE + "/" + actiontype, obj, { headers: this.headers });
    }
  
    /**
     * Retrieves remaining services from the API.
     * @returns An Observable with AvailService structure.
     */
    public retrieveRemainService(): Observable<AvailService> {
      return this.http.get<AvailService>(this.restAPI.RETRIVE_REMAIN_SERVICE, { headers: this.headers });
    }
  
 
}
